<template>
  <!-- The AI finished reading an audit plan, or couldn't (US 9404); the link reopens the import dialog -->
  <div>
    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>
    <div v-if="data.assessment">
      <template v-if="data.status === 'ready'">
        {{ $t('notifications.audit_plan_import.ready', { file: data.file_name || '', template: data.assessment.name }) }}
        <span v-if="data.controls !== null && data.controls !== undefined" class="text-muted">
          ({{ $t('notifications.audit_plan_import.found', { objectives: data.objectives, controls: data.controls }) }})
        </span>
      </template>
      <template v-else>
        {{ $t('notifications.audit_plan_import.failed', { file: data.file_name || '', template: data.assessment.name }) }}
      </template>
      <br />
      <router-link :to="link" qid="notification-audit-plan-import-link">
        {{ data.status === 'ready' ? $t('notifications.audit_plan_import.review') : $t('notifications.audit_plan_import.open') }}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuditPlanImportReadyNotification',
    props: {
      notification: {
        type: Object,
        required: true
      }
    },
    computed: {
      data() {
        return this.notification.data || {};
      },
      link() {
        let query = { import: this.data.id };
        if (this.data.client) {
          query.client = this.data.client;
        }
        return { name: 'maintenance.assessments.view', params: { slug: this.data.assessment.slug }, query: query };
      }
    }
  }
</script>
